var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWatermelon = function SvgWatermelon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watermelon_svg__a)",
    d: "M16 114.529S23.6 187 134.8 187 254 109 254 109z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watermelon_svg__b)",
    d: "M248.559 83.744c-3.01-.992-33.162-.992-36.645 0s-5.49 2.978-9.5 2.978-2.547-2.426-8.8-1.71-9.942-.275-19.633.717-24.739.993-29.755 1.985-12.039 3.581-19.061 2.286-22.071-5.263-27.087-5.263-8.115.992-12.083 0-8.984.992-11.994.992-7.165-.777-16.123 1.1-10.312-1.877-18.663 0-16.377-.107-18.383.885-8.008 13.939-5.007 27.314S38.889 181 135.2 181s117.375-52.6 119.381-71.453c1.887-17.765-3.013-24.81-6.022-25.803"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "watermelon_svg__a",
    x1: 135,
    x2: 135,
    y1: 186.064,
    y2: 106.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    stopColor: "#3295C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#6EB4D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CDE5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "watermelon_svg__b",
    x1: 135.001,
    x2: 135.001,
    y1: 92.212,
    y2: 181.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    stopColor: "#3295C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#6EB4D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CDE5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgWatermelon;